module.exports = __webpack_public_path__ + "static/custom-image-badge-c71c50f04b87321000c077269ea6ec14.png";